<div class="modal-heading modal-heading-1 d-flex flex-row">
    <div class="label_name flex-grow-1">
        {{ 'GUEST_ACCOUNT_REQUIRED_GUARD.ACCOUNT_REQUIRED' | translate }}
    </div>
    <div class="label_name">
        <fa-icon class="cursor" [icon]="['fas','times']" (click)="closeModal()"></fa-icon>
    </div>
</div>
<div class="modal-body modal-body-padding d-flex flex-column">
    <span class="my-4">{{ 'GUEST_ACCOUNT_REQUIRED_GUARD.SIGN_UP_FOR_YOUR_TEACHER' | translate }}</span>
    <div class="d-flex flex-row">
        <a class="btn btn-primary flex-grow-1 mr-3" [routerLink]="registerTeacher" (click)="closeModal()">{{ 'GUEST_ACCOUNT_REQUIRED_GUARD.SIGN_UP' | translate }}</a>
        <a class="btn btn-white flex-grow-1 ml-3" [routerLink]="login" (click)="closeModal()">{{ 'GUEST_ACCOUNT_REQUIRED_GUARD.LOG_IN' | translate }}</a>
    </div>
</div>